
import InProgressIcon from '@material-ui/icons/Autorenew';
import React from 'react';
import { CreateButton } from '../../../buttons';
import { BooleanInput, NestedReferenceInput, ReferenceInput } from '../../../inputs';

export default {
   menuItems: [
    {
      type: 'update',
      name: 'Set "In Progress"',
      icon: InProgressIcon,
      if: mission_achievements => mission_achievements.completed,
      updateAttributes: {completed: false},
    },
  ],
  dialogs: {
    create: props => ( <CreateButton
      fixedValue={{ user_id: props.parentResource.id }}
      {...props}
                       >
      <ReferenceInput
        source="mission_id"
        required
      />
      <NestedReferenceInput
        resourcePath={`/users/${props.parentResource.id}`}
        source="project_id"
        required
      />
      <BooleanInput
        defaultValue={false}
        source="completed"
      />
    </CreateButton>
    ),
  },
  routes: {},
  components: {},
  resources: {},
};
